import { useQuery } from '@apollo/client';

import { TopBannerConfigsDocument } from '@/graphql/types';

import { useErrorBoundary } from 'react-error-boundary';
import { useEffect } from 'react';
import { useProfile } from '../../profile';
import TopBanner from './TopBanner';

function TopBannerContainer(): JSX.Element | null {
    const { isAuthenticated } = useProfile();
    const { showBoundary } = useErrorBoundary();
    const { data, loading, error } = useQuery(TopBannerConfigsDocument, {
        skip: !isAuthenticated,
    });
    const banners = isAuthenticated ? data?.topBannerConfigs ?? [] : [];

    useEffect(() => {
        if (error) {
            showBoundary(error);
        }
    }, [error, showBoundary]);

    if (!isAuthenticated || loading || banners.length === 0) {
        return null;
    }

    return (
        <div>
            {banners.map((banner) => (
                <TopBanner
                    key={banner.id}
                    {...banner.content}
                    cookieName={`hideBanner-${banner.campaignKey}`}
                    cookieTtlDays={banner.cookieTtlDays}
                />
            ))}
        </div>
    );
}

export default TopBannerContainer;
